
import { defineComponent, onMounted, toRef, ref, watchEffect, PropType } from 'vue';
import { CouponsWithImageUrl } from '@/lib/api/coupons.api';

export default defineComponent({
  props: {
    item: {
      required: true,
      type: Object as PropType<CouponsWithImageUrl>,
    },
  },

  setup(props) {
    const item = toRef(props, 'item');
    const canvas = ref<HTMLCanvasElement | null>(null);
    const imageObj = ref<HTMLImageElement | null>(null);


    onMounted(() => {
      if (canvas.value && canvas.value.width && item.value) {
        const context = canvas.value.getContext('2d');
        imageObj.value = new Image();
        imageObj.value.crossOrigin = 'Anonymous';
        imageObj.value.onload = () => {
          if (canvas.value && imageObj.value && imageObj.value.width) {
            canvas.value.width = imageObj.value.width;
            canvas.value.height = imageObj.value.height;
            context.drawImage(imageObj.value, 0, 0);
          }
        };
        imageObj.value.src = item.value.imageUrl;
      }
    });

    watchEffect(async () => {
      if (imageObj.value && imageObj.value.src) {
        imageObj.value.src = item.value.imageUrl;
      }
    });

    return {
      canvas,
    };
  },
});
